module.exports = __webpack_public_path__ + "img/refuse.fd40913a.png";